import { render, staticRenderFns } from "./CreateTG.vue?vue&type=template&id=071f1eae&scoped=true&"
import script from "./CreateTG.vue?vue&type=script&lang=js&"
export * from "./CreateTG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071f1eae",
  null
  
)

export default component.exports